import React, { Component } from 'react';
import { array, bool, func, shape, string } from 'prop-types';

import { connect } from 'react-redux';

import { get } from 'lodash';

import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';

import EsmsModal from '../../components/EsmsModal';
import CancelButton from '../../components/CancelButton';
import ConfirmButton from '../../components/ConfirmButton';

import { updateDeviceProfile } from '../../actions/deviceActions';
import { enqueueSnackbar } from '../../actions/applicationMessageActions';

import validator from '../../helpers/validator';

import classes from './UpdateDeviceProfileModal.module.css';

class UpdateDeviceProfileModal extends Component {
    static defaultProps = {
        updateDeviceProfile: () => {},
        close:               () => {},
        open:                false
    };

    static propTypes = {
        companyInfo: shape({
            companyId: string.isRequired
        }),
        updateDeviceProfile: func,
        devices:             array.isRequired,
        close:               func,
        open:                bool
    };

    state = {
        formIsValid:  false,
        formControls: {
            profile: {
                value:           '',
                placeholder:     'Profile',
                valid:           true,
                touched:         false,
                message:         '',
                validationRules: {

                }
            }
        }
    }

    handleValidation = event => {
        const validatedState = validator(this.state, event);

        this.setState({
            formControls: validatedState.updatedControls,
            formIsValid:  validatedState.formIsValid
        });
    }

    handleChange = event => {
        const { name, value } = event.target;

        const updatedControls = { ...this.state.formControls };

        updatedControls[name].value = value;

        this.setState({
            formControls: updatedControls
        });
    }

    handleUpdate = async () => {
        const { companyInfo, devices, selectedAgent, resetSelectState, updateDeviceProfile } = this.props;
        const basProfileId = this.state.formControls.profile.value;

        const companyId = get(companyInfo, 'companyId', '');

        const isUpdated = updateDeviceProfile(companyId, selectedAgent, devices, basProfileId);

        if (isUpdated) {
            resetSelectState();
            this.handleClose();
        }
    }

    handleClose = () => {
        this.props.close();
    }

    render() {
        let { open, devices, profiles } = this.props;

        return (
            <EsmsModal
                imgSrc="/assets/images/profilesIconColor.svg"
                open={open}
                onClose={this.handleClose}
                title={`Update ${devices.length} device(s)`}
                classes={classes}
            >
                <p>
                    Warning: Updating a Profile for a Device will replace existing Device Objects with the Objects defined in the Profile.
                </p>
                <p>
                    Are you sure you wish to update the Profile for these devices:
                </p>
                <ul className={classes.listScroll}>
                    {devices.map(({ id, name }) => (
                        <li key={id}>
                            {name}
                        </li>
                    ))}
                </ul>
                <FormControl className={classes.inputWrapper}>
                    <InputLabel
                        htmlFor="profile"
                        classes={{
                            focused: classes.labelFocused,
                            root:    classes.label
                        }}
                    >
                        {this.state.formControls.profile.placeholder}
                    </InputLabel>
                    <Select
                        value={this.state.formControls.profile.value}
                        onChange={this.handleChange}
                        className={classes.select}
                        inputProps={{
                            name:   'profile',
                            id:     'profile',
                            onBlur: this.handleValidation
                        }}
                    >
                        {
                            profiles.map(profile =>
                                this.props.selectedAgent.driverConfiguration[0].basType.toString() === profile.basType &&
                                <MenuItem
                                    className={classes.selectMenuItem}
                                    value={profile.id}
                                    key={profile.id}
                                >
                                    {profile.name}
                                </MenuItem>
                            )
                        }
                    </Select>
                    {!this.state.formControls.profile.valid &&
                              this.state.formControls.profile.touched && <FormHelperText className={classes.error}>{this.state.formControls.profile.message}</FormHelperText>}
                </FormControl>
                <div className={classes.buttonContainer}>
                    <CancelButton
                        cancel={this.handleClose}
                    />
                    <ConfirmButton
                        label="confirm"
                        type="button"
                        confirm={this.handleUpdate}
                        disabled={!this.state.formIsValid}
                    />
                </div>
            </EsmsModal>
        );
    }
}

UpdateDeviceProfileModal.defaultProps = {
    devices:  [],
    profiles: []
};

UpdateDeviceProfileModal.propTypes = {
    devices:  array,
    profiles: array
};

const mapStateToProps = ({ companyInfo, basAgent, profile }) => {
    const { basAgents: agents, selectedAgentId } = basAgent;
    const selectedAgent = agents[selectedAgentId];
    return {
        companyInfo,
        profiles: profile.profiles,
        selectedAgent
    };
};

const mapDispatchToProps = {
    enqueueSnackbar,
    updateDeviceProfile
};

export default connect(mapStateToProps, mapDispatchToProps)(UpdateDeviceProfileModal);
